// extracted by mini-css-extract-plugin
export default {"wrapper":"GenresPopper_wrapper__SvKTu","genre-popper-btn":"GenresPopper_genre-popper-btn__Hl7Es"};